import {
  createSlice,
} from '@reduxjs/toolkit';
import { setBaseState } from '../../../store/utils/setStoreState';

export const MAKE3DSFLOW = {
  NONEFLOW: 'noneFlow',
  PRE3DSFLOW: 'pre3dsFlow',
  COM3DSFLOW: 'com3dsFlow',
};

const make3dsSlice = createSlice({
  name: 'make3ds',
  initialState: {
    submitParams: {},
    make3dsFlow: MAKE3DSFLOW.NONEFLOW,
  },
  reducers: {
    setSubmitParams: setBaseState('submitParams'),
    setMake3dsFlow: setBaseState('make3dsFlow'),
  },
});

export const {
  setSubmitParams, setMake3dsFlow,
} = make3dsSlice.actions;

export default make3dsSlice.reducer;
